var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "c-confirmation-box__wrapper c-confirmation-box__wrapper--after"
      },
      [
        _c("div", { staticClass: "c-confirmation-box" }, [
          _vm.title
            ? _c("h2", { staticClass: "c-confirmation-box__title" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "c-confirmation-box__description",
            domProps: { innerHTML: _vm._s(_vm.message) }
          }),
          _vm._v(" "),
          _vm.reference
            ? _c("div", { staticClass: "c-confirmation-box__incident" }, [
                _vm._v("Incident Number: "),
                _c(
                  "span",
                  { staticClass: "c-confirmation-box__incident-number" },
                  [_vm._v(_vm._s(_vm.reference))]
                )
              ])
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _vm.confirmationCtaUrl
      ? _c("div", { staticClass: "c-confirmation-box__actions" }, [
          _c(
            "a",
            {
              staticClass: "c-button c-button--brand c-button--text-center",
              attrs: { href: _vm.confirmationCtaUrl }
            },
            [_vm._v("\n      " + _vm._s(_vm.confirmationCtaText) + "\n    ")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c826033", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c826033","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/_contact-us-rap/_vue/ConfirmationBox.vue
// module id = 683
// module chunks = 0